import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GestockService } from '../services/gestock.service';

@Component({
    selector: 'app-stock-reception',
    templateUrl: './stock-reception.component.html',
    styleUrls: ['./stock-reception.component.css']
})
export class StockReceptionComponent implements OnInit {

    samacaabiyoonwii = "";
    pendingTransfers: any[] = [];
    selectedTransfer: any = null;
    depots: any[] = [];
    selectedDepot: string = '';

    constructor(
        public dialogRef: MatDialogRef<StockReceptionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private gestockService: GestockService
    ) {
        this.depots = data.depots; // Assuming we pass the list of depots of the current shop
    }

    ngOnInit(): void {
        this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
        this.loadPendingTransfers();
    }

    loadPendingTransfers() {
        this.gestockService.getPendingTransfers(this.samacaabiyoonwii).then(res => {
            if (res.statutreq == 1) {
                this.pendingTransfers = res.data;
            } else {
                console.error("Error loading transfers", res.message);
            }
        });
    }

    selectTransfer(transfer: any) {
        this.selectedTransfer = transfer;
        // Initialize received quantities with what was sent
        this.selectedTransfer.items.forEach(item => {
            item.qteRecu = item.qte;
        });
    }

    cancelSelection() {
        this.selectedTransfer = null;
    }

    validateReception() {
        if (!this.selectedDepot) {
            alert("Veuillez sélectionner un dépôt de réception.");
            return;
        }

        const quantiteInvalide = this.selectedTransfer.items.find(item =>
            item.qteRecu === null || item.qteRecu === undefined || item.qteRecu < 0 || item.qteRecu > item.qte);
        if (quantiteInvalide) {
            alert("Quantité reçue invalide pour « " + (quantiteInvalide.nom || quantiteInvalide.name) + " » : elle doit être comprise entre 0 et " + quantiteInvalide.qte + ".");
            return;
        }

        const itemsToReceive = this.selectedTransfer.items.map(item => ({
            id: item.id,
            nom: item.nom || item.name, // le transfert enregistre "nom"
            qte: item.qteRecu
        }));

        this.gestockService.validateReception(this.samacaabiyoonwii, this.selectedTransfer.id, this.selectedDepot, itemsToReceive)
            .then(res => {
                if (res.statutreq == 1) {
                    alert("Réception validée avec succès !");
                    this.selectedTransfer = null;
                    this.loadPendingTransfers(); // Refresh list
                } else {
                    alert("Erreur: " + res.message);
                }
            });
    }

    close() {
        this.dialogRef.close();
    }
}
